
import { Routes, Route } from "react-router-dom";
import Homepage from './pages/Homepage/Homepage';
import Markets from './pages/Markets/Markets';
import Product from './pages/Product/Product';
import Products from './pages/Products/Products';

import Header from './components/Header';
import Footer from './components/Footer';

import useColor from './hooks/useColor';
import inventory from "./lib/inventory.json";

function App() {
  const [color] = useColor();

  return (
    <div className={`App bg bg-image-${color}`}>
      <Header color={color} />
      <Routes>
        <Route path="/" element={<Homepage color={color} />} />
        <Route path="/markets" element={<Markets color={color} />} />
        <Route path="/products" element={<Products color={color} />} />
        {
          Object.keys(inventory).map((collection) => {
            return inventory[collection].map((item) => {
              const siblings = inventory[collection].filter((sibling) => sibling.category !== item.category);
              return (
              <Route path={`/${collection}/${item.category}`} element={<Product color={color} details={item} siblings={siblings} />} />
              )})
          })
        }
        {/* TODO: add route for markets, past and upcoming. Use json with stored date/time and separate based on past/future */}
      </Routes>
      <Footer color={color} />
    </div>
  );
}

export default App;
